import { render, staticRenderFns } from "./SectionFeatures.vue?vue&type=template&id=55153812&"
import script from "./SectionFeatures.vue?vue&type=script&lang=js&"
export * from "./SectionFeatures.vue?vue&type=script&lang=js&"
import style0 from "./SectionFeatures.vue?vue&type=style&index=0&id=55153812&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,AtomsCommonAtomVerticalLine: require('/app/components/atoms/common/AtomVerticalLine.vue').default,OrganismsCommonOrganismListCircle: require('/app/components/organisms/common/OrganismListCircle.vue').default})
